import Wrapper from "../assets/wrappers/Client";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { AiFillStar } from "react-icons/ai";
import { BsChatRightQuote } from "react-icons/bs";

const Client = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1, // Changed to 1 for smoother ux
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  };

  const reviews = [
    {
      name: "Elie E.",
      title: "Professional and very knowledgeable.",
      text: "I came with chronic neck and shoulder pain, and after a few sessions I felt a real difference. The treatment was well explained and tailored exactly to my condition. Highly recommended."
    },
    {
      name: "Nicole M.",
      title: "Excellent care and great results.",
      text: "What I appreciated most was the attention to detail and the personalized approach. I felt supported throughout my recovery and saw improvement faster than expected."
    },
    {
      name: "Christina A.",
      title: "Dr. Paul is very professional.",
      text: "I had lower back pain for months and started feeling better after a few sessions. He explains things clearly and really listens."
    },
    {
      name: "Rony A.",
      title: "Felt improvement quickly.",
      text: "What I liked is that every session was different depending on how I felt that day."
    },
    {
      name: "Christina E.",
      title: "I’m happy with the results.",
      text: "Dr. Paul takes his time and focuses on the real problem, not just the pain."
    },
    {
      name: "Ghada A.",
      title: "You can trust him.",
      text: "Professional, calm, and honest. I felt safe during the treatment and noticed real progress."
    },
    {
      name: "Verified Patient",
      title: "Worth it.",
      text: "After trying different places, this was the first time I felt the treatment was personalized."
    },
    {
      name: "Verified Patient",
      title: "Simply different!",
      text: "I tried so many methods and nothing worked, except Dr. Paul’s approach, it’s really different from anything else in the world of physiotherapy!"
    }
  ];

  return (
    <Wrapper name="reviews">
      <div className="container">
        <h3 data-aos="zoom-in">
          <BsChatRightQuote className="icon-quote" />
        </h3>

        <div className="reviews">
          <Slider {...settings}>
            {reviews.map((review, index) => (
              <div className="client" key={index}>
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <p data-aos="fade-up" style={{ marginBottom: '15px' }}>
                    <span style={{ display: 'block', fontWeight: '700', marginBottom: '8px', color: 'var(--secondary-color)', fontSize: '1.1rem' }}>
                      {review.title}
                    </span>
                    "{review.text}"
                  </p>
                  <div style={{ marginTop: 'auto' }}>
                    <div className="star-icon-container">
                      {[...Array(5)].map((_, i) => (
                        <AiFillStar key={i} className="star-icon" />
                      ))}
                    </div>
                    <h4>{review.name}</h4>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </Wrapper>
  );
};

export default Client;
